import { IWarehouses } from '../../interfaces';

export const warehouses: IWarehouses[] = [
    {
        id: 11260,
        codigo_erp: '21221',
        domicilio: 'General Gregorio Aráoz de Lamadrid 1360, Buenos Aires, Ciudad Autónoma de Buenos Aires, Argentina',
        descripcion: 'Barracas',
        latitud: '-34.6403696',
        longitud: '-58.3715816',
    },
    {
        id: 11342,
        codigo_erp: '123478',
        domicilio: 'Av. Juan Bautista Alberdi 6200, Ciudad Autónoma de Buenos Aires, Buenos Aires, Argentina',
        descripcion: 'Mataderos',
        latitud: '-34.6544853',
        longitud: '-58.5055079',
    },
    {
        id: 12567,
        codigo_erp: '',
        domicilio: 'Falucho 4245, Tortuguitas, Buenos Aires, Argentina',
        descripcion: 'Tortuguitas',
        latitud: '-34.4614571',
        longitud: '-58.738472',
    },
    {
        id: 26340,
        codigo_erp: '',
        domicilio: 'RN12 1028, Corrientes, Argentina',
        descripcion: 'Raosa',
        latitud: '-27.50147288678726',
        longitud: '-58.77408314789004',
    },
    {
        id: 26540,
        codigo_erp: '',
        domicilio: 'F6XG+J6 Corrientes, Argentina',
        descripcion: 'Corrientes (Raosa)',
        latitud: '-27.5009375',
        longitud: '-58.7744375',
    },
    {
        id: 27057,
        codigo_erp: '',
        domicilio: 'Rondeau 4044, C1262ACJ Cdad. Autónoma de Buenos Aires, Argentina',
        descripcion: 'Hernán Casa',
        latitud: '-34.63752569368117',
        longitud: '-58.420899296438066',
    },
    {
        id: 28215,
        codigo_erp: '',
        domicilio: 'Av. 10 1994, Necochea, Provincia de Buenos Aires, Argentina',
        descripcion: 'Prueba QM',
        latitud: '-38.5729122',
        longitud: '-58.7166382',
    },
    {
        id: 28242,
        codigo_erp: 'Bh',
        domicilio: 'Bahía Blanca, Provincia de Buenos Aires, Argentina',
        descripcion: 'bahia',
        latitud: '-38.7183177',
        longitud: '-62.2663478',
    },
    {
        id: 28495,
        codigo_erp: '',
        domicilio: 'Azul, Provincia de Buenos Aires, Argentina',
        descripcion: 'Azul',
        latitud: '-36.7749672',
        longitud: '-59.8540382',
    },
];
